// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hPGJ0","left":"styles_left__fjFWS","desktopActions":"styles_desktopActions__2L3B5","title":"styles_title__1r-Ow"};